import styled from 'styled-components';
import { rgba } from 'polished';

// CONSTANTS
import { breakpoints } from '@/utility/breakpoints';
import { FUCHSIA_BLUE, MAIN_BLACK, ROYAL_BLUE_2, WHITE } from '../../../../constants/colors';

// UTILITY

export const Container = styled.section`
  @keyframes fadein {
    0%,
    25% {
      pointer-events: none;
      opacity: 0;
    }
    50% {
      opacity: 0.3;
    }
    75% {
      opacity: 0.6;
    }
    100% {
      pointer-events: all;
      opacity: 1;
    }
  }

  @keyframes fadeout {
    0%,
    25% {
      pointer-events: all;
      opacity: 1;
    }
    50% {
      opacity: 0.6;
    }
    75% {
      opacity: 0.3;
    }
    100% {
      pointer-events: none;
      opacity: 0;
    }
  }

  .collapsible-section,
  &.collapsible-section {
    border-top-right-radius: 40px;
    border-top-left-radius: 40px;
    margin-bottom: -80px;
    padding-bottom: 80px;
    position: relative;
    overflow: hidden;
    transition: all 300ms ease;
    z-index: 0;

    ${breakpoints.down('sm')} {
      border-top-right-radius: 16px;
      border-top-left-radius: 16px;
      margin-bottom: -56px;
      padding-bottom: 56px;
    }

    &--cursor-pointer {
      cursor: pointer;
    }

    &--disable-rounding {
      border-radius: 0;
    }

    &--blue {
      background-color: ${ROYAL_BLUE_2};
      .collapsible-section__collapsed-content {
        color: ${WHITE};
      }
    }

    &--white {
      background-color: ${WHITE};
      .collapsible-section__collapsed-content {
        color: ${p => p.theme.palette.text.primary};
      }
    }

    &--purple {
      background-color: ${FUCHSIA_BLUE};
      .collapsible-section__collapsed-content {
        color: ${WHITE};
      }
    }

    &--black {
      background-color: ${MAIN_BLACK};
      .collapsible-section__collapsed-content {
        color: ${WHITE};
      }

      .pros-cons-list--with-icons .pcl-item::before {
        color: ${WHITE};
        background: ${rgba(WHITE, 0.2)};
      }
    }

    &--fadein {
      opacity: 1;
      animation: fadein 300ms linear;
    }

    &--fadeout {
      opacity: 0;
      animation: fadeout 300ms linear;
    }

    &--opened {
      margin-bottom: -120px;

      ${breakpoints.down('sm')} {
        margin-bottom: -96px;
      }
    }

    &--hide {
      opacity: 0;
    }

    &--shadow {
      box-shadow: 0px 4px 24px 0px ${rgba(MAIN_BLACK, 0.15)};
    }

    &:not(&--opened) {
      &:hover {
        ${breakpoints.up('sm')} {
          transform: translateY(-40px);
          box-shadow: 0px 4px 24px 0px ${rgba(MAIN_BLACK, 0.25)};
        }
      }
    }

    &__collapsed-content {
      width: 100%;
      max-width: 1110px;
      margin: 0 auto;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0px 15px;
      height: 160px;
      position: absolute;
      top: 0;
      left: 50%;
      transform: translate(-50%, 0);
      z-index: 1;

      ${breakpoints.down('xs')} {
        height: 100px;
      }
    }

    &__title {
      max-width: 445px;

      ${breakpoints.down('xs')} {
        h4 {
          font-size: 26px;
          line-height: 28px;
        }
      }
    }

    &__button {
      max-width: 276px;
    }
  }
`;

export default Container;
